/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

export const buildUsers = (data: any) =>
  data &&
  data.map((obj: any) => ({
    key: `${obj.first_name} ${obj.last_name}`,
    value: obj.email,
  }));
